import './StorageInfo.css';

export const tableHeader: {
  accessor: string;
  Header: string;
  className: string;
}[] = [
  {
    accessor: 'projectName',
    Header: 'Project',
    className: 'projectNameColumnWidth',
  },
  {
    accessor: 'experimentName',
    Header: 'Experiment',
    className: 'experimentNameColumnWidth',
  },
  {
    accessor: 'dateDispensed',
    Header: 'Date Dispense',
    className: 'dateDispenseColumnWidth',
  },
  {
    accessor: 'userName',
    Header: 'User',
    className: 'userColumnWidth',
  },
  {
    accessor: 'plateId',
    Header: 'Plate ID',
    className: 'plateIdColumnWidth',
  },
  {
    accessor: 'imageStoreName',
    Header: 'Data Store',
    className: 'dataStorageColumnWidth',
  },
  {
    accessor: 'cumulativeFileSize',
    Header: 'Total Size(MB)',
    className: 'totalSizeColumnWidth',
  },
];

export const STORAGE_INFO_TASK_ID = 'storageInfoTaskId';
